<template>
  <div id="app">
    <div class="route-con">
      <router-view  v-if="routerState"/>
    </div>
  </div>
</template>

<script>
import Layout from "./views/Layout";

export default {
  name: "App",
  provide(){
    return {
      reload:this.reload
    }
  },
  data(){
return{
  routerState:true,
}
  },
  methods:{
     reload(){
        this.routerState = false;
        this.$nextTick(()=>{
          this.routerState = true;
        })
      }
  }
};
</script>
<style>
@import "./util/font.css";
html,
body {
  margin: 0;
  padding: 0;
  height: 100%;
  overflow-x: hidden;
  position: relative;
}
#app {
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
  font-size: 10px; /*1rem == 10px */
  color: white;
  background: black;
}

</style>
<style scoped lang="scss">
.route-con {
  height: 100%;
  position: relative;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/App.vue